/**
 * TrackerV2 主导出文件
 * 提供完整的埋点架构接口
 */

// 核心模块
export { trackerV2, TrackerV2 } from "./core/TrackerV2";
export type { TrackOptions } from "./core/TrackerV2";

// 上下文管理
export {
  contextManager,
  SearchContext,
  NavigationContext,
  PinDetailContext,
} from "./context";
export type {
  Context,
  SearchContextData,
  NavigationContextData,
  PinDetailContextData,
} from "./context";

// 数据增强器
export { enricherManager } from "./enricher";
export type { DataEnricher, EnrichContext, EnrichOptions } from "./enricher";

// 事件管理
export { eventBus } from "./event";
export type { TrackEvent, EventInterceptor, EventListener } from "./event";

// 数据校验
export { validator } from "./validator";
export type { TrackSchema, ValidationResult } from "./validator";

// 数据缓冲
export { Buffer } from "./buffer";
export type { BufferOptions } from "./buffer";

// 上报管理
export { reporter } from "./reporter";
export type { ReporterOptions } from "./reporter";

// React 组件和 Hooks
export { Track, trackDataRegistry } from "./components";
export type { TrackProps, TrackConfig } from "./components";

export { useTrack, useTrackCallback, useTrackEffect } from "./hooks";
export type { UseTrackOptions } from "./hooks";

// 配置
export {
  getMigrationConfig,
  setMigrationConfig,
  shouldUseV2,
  enableEventV2,
  enablePageV2,
  enableGlobalV2,
  disableEventV2,
  disableGlobalV2,
  PAGE_CONTEXTS,
  getPageContextTypes,
  needsContext,
  isSearchPage,
  isDetailPage,
} from "./config";
export type { MigrationConfig } from "./config";

// 适配器和集成（保留用于渐进式迁移，但新版不依赖）
export { autoTriggerAdapter } from "./adapter";
export { integrateWithAutoTrigger, initTrackerV2 } from "./integration";

// 工具函数
export { getPageInfo } from "./utils/getPageInfo";
export type { PageInfo } from "./utils/getPageInfo";

// 日志工具
export { TrackerLogger } from "./utils/logger";

// 拦截器（保留接口，但不干预旧版埋点）
export {
  registerTrackerV2Interceptor,
  initTrackerV2Interceptor,
} from "./interceptor";

// 业务埋点组件（封装常见业务场景）
export { CollectButton, MaterialCard, trackSearch } from "./business";
export type {
  CollectButtonProps,
  MaterialCardProps,
  TrackSearchOptions,
} from "./business";
